export const MenuItems = [
{
    title: 'Africa',
    path: '/Africa',
    cName: 'dropdown-link'
},
{
    title: 'Asia',
    path: '/Asia',
    cName: 'dropdown-link'
},
{
    title: 'Australia',
    path: '/Australia',
    cName: 'dropdown-link'
}
,
{
    title: 'Europe',
    path: '/Europe',
    cName: 'dropdown-link'
},
{
    title: 'North America',
    path: '/America',
    cName: 'dropdown-link'
},
{
    title: 'South America',
    path: '/SouthAmerica',
    cName: 'dropdown-link'
}
];